module.exports = __webpack_public_path__ + "static/media/guide_correct.87647a89.png";